












































import { Vue, Component, Mixins } from "vue-property-decorator";
import moment from "moment";
import _ from "lodash";
import MyCommon from "@/mixins/common";

import VChart, { THEME_KEY } from "vue-echarts";

import SelectStadium from "@/components/selectstadium.vue";

@Component({
  components: {
    SelectStadium,
    VChart
  },
  provide: {
    [THEME_KEY]: "light"
  }
})
export default class extends Mixins(MyCommon) {
  form1: any;

  searchData1: any = {
    stadium_id: "260",
    created_time1: moment().format("YYYY") + "-01-01 00:00:00",
    created_time2: moment().format("YYYY-MM-DD") + " 23:59:59"
  };

  ei: any = {};

  chartOption: any = {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "cross",
        crossStyle: {
          color: "#999"
        }
      }
    },

    legend: {
      data: ["打卡成功", "未打卡", "比例"]
    },
    xAxis: [
      {
        type: "category",
        data: []
      }
    ],
    yAxis: [
      {
        type: "value",
        name: "次数(次)"
      },
      {
        type: "value",
        name: "比例(%)"
      }
    ],
    series: [
      {
        name: "打卡成功",
        type: "bar",
        stack: "sd2",
        tooltip: {
          valueFormatter: (value: any) => {
            return value + " 次";
          }
        },
        data: []
      },
      {
        name: "未打卡",
        type: "bar",
        stack: "sd2",
        tooltip: {
          valueFormatter: (value: any) => {
            return value + " 次";
          }
        },
        data: []
      },
      {
        name: "比例",
        type: "line",
        yAxisIndex: 1,
        tooltip: {
          valueFormatter: (value: any) => {
            return value + " %";
          }
        },
        data: []
      }
    ]
  };

  beforeCreate() {
    this.form1 = this.$form.createForm(this, {});
  }

  mounted() {
    this.loadData11();
  }

  async loadData11() {
    this.chartOption.xAxis[0].data = [];
    this.chartOption.series[0].data = [];
    this.chartOption.series[1].data = [];
    this.chartOption.series[2].data = [];
    const res = await this.$store.dispatch("stadiumcrm/statistics", {
      ...this.searchData1
    });

    // console.log(res);
    if (res && res.Data) {
      this.chartOption.xAxis[0].data = res.Data.categories;

      for (const k in res.Data.data) {
        if (res.Data.data[k]) {
          this.chartOption.series[0].data.push(res.Data.data[k]);
        } else {
          this.chartOption.series[0].data.push(0);
        }
      }

      for (const k in res.Data.data1) {
        if (res.Data.data1[k]) {
          this.chartOption.series[1].data.push(res.Data.data1[k]);
        } else {
          this.chartOption.series[1].data.push(0);
        }
      }

      for (const k in res.Data.percent) {
        if (res.Data.percent[k]) {
          this.chartOption.series[2].data.push(res.Data.percent[k]);
        } else {
          this.chartOption.series[2].data.push(0);
        }
      }
    }
  }

  handleSearch(e: any) {
    e.preventDefault();
    this.form1.validateFields(async (err: any, fieldsValue: any) => {
      if (!err) {
        this.searchData1.stadium_id = fieldsValue.stadium_id;
        this.searchData1.created_time1 = fieldsValue.created_time1.format("YYYY-MM-DD HH:mm:ss");
        this.searchData1.created_time2 = fieldsValue.created_time2.format("YYYY-MM-DD HH:mm:ss");
        this.loadData11();
      }
    });
  }
}
